import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../theme';

const propTypes = {
  text: PropTypes.string,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  onSelectionChanged: PropTypes.func
};

const RadioButton = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let radioButton;
  if (theme && theme.radioButton) {
    radioButton = theme.radioButton;
  } else {
    radioButton = context.theme.radioButton;
  }
  const {
    isHandOnHover,
    radioBtnColor,
    radioBtnHoverColor,
    radioBtnSelectedColor,
    radioBtnDisabledColor
  } = radioButton;

  const { isSelected, isDisabled } = props;

  const styles = StyleSheet.create({
    containerStyles: {
      color: radioBtnColor,
      borderColor: radioBtnColor,
      display: 'flex',
      alignItems: 'center',
      cursor: isHandOnHover ? 'pointer' : 'initial',
      ':hover': {
        color: radioBtnHoverColor,
        borderColor: radioBtnHoverColor
      }
    },
    radioBtn: {
      width: '18px',
      height: '18px',
      background: 'transparent',
      border: '2px solid #507090',
      borderRadius: '50%',
      borderColor: 'inherit',
      position: 'relative'
    },
    selectedRadioBtn: {
      borderColor: radioBtnSelectedColor,
      background: 'transparent'
    },
    disabledRadioBtn: {
      borderColor: radioBtnDisabledColor,
      background: 'transparent'
    },
    radioFill: {
      width: '10px',
      height: '10px',
      borderWidth: '0px',
      background: radioBtnSelectedColor,
      borderRadius: '50%',
      transform: 'translate(2px, 2px)'
    },
    disabledRadioFill: {
      background: radioBtnDisabledColor
      // transform: 'translate(2px, 2px)'
    },
    spanStyles: {
      marginLeft: '5px',
      paddingTop: '2px'
    },
    selectedText: {
      color: radioBtnSelectedColor
    },
    disabledText: {
      color: radioBtnDisabledColor
    }
  });

  return (
    <div
      className={`${props.className || ''} ${css(styles.containerStyles)}`}
      onClick={props.onSelectionChanged}
    >
      <div
        className={css(
          styles.radioBtn,
          isSelected && styles.selectedRadioBtn,
          isDisabled && styles.disabledRadioBtn
        )}
        onClick={props.onSelectionChanged}
      >
        {isSelected
          ? <div className={css(styles.radioFill, isDisabled && styles.disabledRadioFill)}/>
          : null}
      </div>
      <span
        onClick={props.onSelectionChanged}
        className={css(
          styles.spanStyles,
          isSelected && styles.selectedText,
          isDisabled && styles.disabledText
        )}
      >
        {props.text}
      </span>
    </div>
  );
};

RadioButton.propTypes = propTypes;
export { RadioButton };
